import React, { useState,useEffect,useRef,useCallback } from 'react';
import Select, { components } from 'react-select';
import { ReceivedDate } from './DatePicker';
import * as HELPER from "../../src/config/helper";
// import ChequeDetails from './ChequeDetails';
import { updateLeadEmiDetail } from '../../src/store/slices/insurance';
import { useParams } from "react-router-dom";
import FullPageLoader from '../../src/common/FullPageLoader';
import ConfirmPopUp from '../../src/common/ConfirmPopUp';
import FollowUpPopup from '../../src/lead/common/FollowUpPopup';
import { getMasterConfig,addDocument,getBankList } from '../../src/store/slices/common';
import { useDispatch,useSelector } from 'react-redux';
import { RAGEX_NUMBER_UPTO_2_DECIMAL_PLACES,PAYMENT_DISSABLE_STATUS,ALERT_STATUS,PAYMENT_TYPE_RADIO,POST_DATED_CHEQUE_ID,LEAD_LOST_SUB_STATUS_ID,PAYSO_QR_PAYMENT_ID,PARTNERS_ONLY_FOR_CREDIT_CARD } from '../../src/config/constant';
import EmiInstallmentActions from './EmiInstallmentActions';

const PAYSO_PAYMENT_ID = PAYSO_QR_PAYMENT_ID;
const PAYSO_QR_VERIFIED_TEXT = "Payso QR Verified";
const CREDIT_CARD_PAYMENT_ID = "credit-card";

const { ValueContainer, Placeholder } = components;

const CustomValueContainer = (props: any) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(props.children, (child: any) =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};

const EmiComponent = ({ emiData, isInstallments,isPaymentMethodChecq,reloadEmiDetails,totalEmildetail,selectedIndex,isPaymentTypeShow,isWholeLeadPaymentDone,leadDetail,setCallReloadApi,leadSubStatusId,isOverpaidTab = false,setLeadDetailLoading }: { emiData: any, isInstallments: boolean,isPaymentMethodChecq:boolean,reloadEmiDetails: () => void | Promise<void>;totalEmildetail:any, selectedIndex:number,isPaymentTypeShow:boolean,isWholeLeadPaymentDone:boolean,leadDetail:any,setCallReloadApi:any,callReloadApi:any,leadSubStatusId:number,isOverpaidTab?:boolean,setLeadDetailLoading?: (isLoading: boolean) => void}) => {
    const dispatch: any = useDispatch();
    const { id } = useParams<{ id: string }>()
    const [paidTo, setPaidTo] = useState<any[]>([]);
    const [paymentMethod, setPaymentMethod] = useState<any[]>([]);

    const [paidByCustomer, setPaidByCustomer] = useState<any[]>([]);

    const [payments, setPayments] = useState<any[]>([]);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [followUpPopup, setFollowUpPopup] = useState(false);

    const [errors, setErrors] = useState<any>({});

    const [loading, setLoading] = useState<boolean>(false);
    const isLeadDetailLoaderControlled = typeof setLeadDetailLoading === 'function';
    const setPageLoading = useCallback((isLoading: boolean) => {
        setLoading(isLoading);
        setLeadDetailLoading?.(isLoading);
    }, [setLeadDetailLoading]);

    const [IssuingBank, setIssuingBank] = useState<any[]>([]);

    const commonState = useSelector((state: any) => state.common);
    const leadProcessingDetails = useSelector((state: any) => state.insurance.leadDetail);
    const leadProcessingDetail = Array.isArray(leadProcessingDetails) ? leadProcessingDetails[0] : leadProcessingDetails;

    // const [chequeDetails, setChequeDetails] = useState({
    //     cheque_no: emiData?.cheque_no || "",
    //     cheque_issue_date: emiData?.cheque_issue_date || "",
    //     cheque_due_date: emiData?.cheque_due_date || "",
    //     cheque_issuing_bank: +emiData?.cheque_issuing_bank || 0,
    // });

    // const [paymentFiles, setPaymentFiles] = useState<{ [key: number]: File | null }>({});

    const [paymentFiles, setPaymentFiles] = useState<{[key: number]: { name: string; url: string } | File | null;}>({});

    // const [isChqueDissable, setIsChqueDissable] = useState(false);

    const fileInputRefs = useRef<{ [key: number]: HTMLInputElement | null }>({});

    const [isNewRecord, setIsNewRecord] = useState(false);

    const [isLostStatusVisible,setIsLostStatusVisible] = useState<boolean>(true);
    const overpaidPayments = leadDetail?.overpaid_payments;
    const createEmptyPayment = useCallback(() => ({
        lead_installment_id: emiData?.id || null,
        received_amount: '',
        payment_date: null,
        payment_type: null,
        paid_to: null,
        transaction_id : emiData?.transaction_id || null,
        paid_by_customer : 0,
        status : null
    }), [emiData?.id, emiData?.transaction_id]);
   
    useEffect(() => {
        if (isOverpaidTab) {
            const updatedPayments = Array.isArray(overpaidPayments) && overpaidPayments.length > 0 ? overpaidPayments.map((payment : any) => ({
                ...payment,
                finance_reco_status : payment.status,
                amount_to_show: payment.amount_to_show ?? payment.received_amount
            })) : [createEmptyPayment()];
            setPayments(updatedPayments);
            setPaymentFiles({});
            setErrors({});
            return;
        }
        // isInstallments && 
        if (Array.isArray(emiData?.Payments) && emiData.Payments.length > 0) {
            // finance_reco_status: isPaymentMethodChecq ? payment.finance_status : payment.reco_status
            const updatedPayments = emiData.Payments.map((payment : any) => ({
                ...payment,
                finance_reco_status : payment.status,
                transaction_id: payment?.transaction_id ? payment.transaction_id : emiData.transaction_id
            }));
            setPayments(updatedPayments);
        } else {
            const singlePayment = {
                ...createEmptyPayment(),
                received_amount: emiData?.received_amount,
                payment_date: emiData?.payment_date,
                payment_type: emiData?.payment_type,
                paid_to: emiData?.paid_to,
            };
            setPayments([singlePayment]);
        }
        // setChequeDetails({
        //     cheque_no: emiData?.cheque_no || "",
        //     cheque_issue_date: emiData?.cheque_issue_date || "",
        //     cheque_due_date: emiData?.cheque_due_date || "",
        //     cheque_issuing_bank: emiData?.cheque_issuing_bank || "",
        // });
        // const isDisabled = !!(
        //   (emiData?.cheque_no && emiData?.cheque_no.trim() !== "") ||
        //   (emiData?.cheque_issue_date && emiData?.cheque_issue_date !== "") ||
        //   (emiData?.cheque_due_date && emiData?.cheque_due_date !== "") ||
        //   (emiData?.cheque_issuing_bank && Number(emiData?.cheque_issuing_bank) !== 0)
        // );
        // setIsChqueDissable(isDisabled);
        setPaymentFiles({});
        setErrors({});
    }, [emiData, isInstallments, isOverpaidTab, overpaidPayments, createEmptyPayment]);

    useEffect(() => {
        if (!leadDetail?.emi_details?.length) {
            setIsLostStatusVisible(true);
            return;
        }
        const hasValidPayment = leadDetail?.emi_details.some((emi: any) => emi?.Payments?.some((payment: any) => {
            return (PAYMENT_DISSABLE_STATUS.includes(payment.status))})
        );
        setIsLostStatusVisible(!hasValidPayment);
        // console.log("leadDetail?.emi_details",leadDetail?.emi_details);
        // // Check if ANY installment has payments
        // const hasAnyPayment = leadDetail.emi_details.some((emi: any) => Array.isArray(emi.Payments) && emi.Payments.length > 0);
        // if (hasAnyPayment) {
        //     setIsLostStatusVisible(false);
        // } else {
        //     setIsLostStatusVisible(true);
        // }
    }, [leadDetail]);

    useEffect(() => {
        const newPaymentFiles: {
            [key: number]: { name: string; url: string } | File | null;
        } = {};

        payments.forEach((payment, index) => {
            if (payment.proof_url) {
            const fileName = payment.payment_proof?.split('/').pop() || 'proof';
            newPaymentFiles[index] = {
                name: fileName,
                url: payment.proof_url,
            };
            }
        });
        setPaymentFiles(prev => ({
        ...prev,           
        ...newPaymentFiles 
        }));
    }, [payments]);

    const handleFieldChange = (index: number, field: string, value: any) => {
        // Allow empty value to support clearing the field
        if (field === "received_amount" && value !== "" && !RAGEX_NUMBER_UPTO_2_DECIMAL_PLACES.test(value)) {
            return;
        }
        setPayments((prevPayments:any) => {
            const updatedPayments = [...prevPayments];
            const updatedPayment = { ...updatedPayments[index] };
            updatedPayment[field] = value;
            updatedPayments[index] = updatedPayment;
            return updatedPayments;
        });
        errors[`${field}_${index}`] = '';
        setErrors({ ...errors });
        
    };

    const getAmountInCents = (value: any) => {
        if (value === null || value === undefined || value === "") return 0;
        const amount = Number(String(value).replace(/[^0-9.-]/g, ""));
        return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
    };

    const isAmountPaid = (receivedAmount: any, expectedAmount: any) => {
        const expectedAmountInCents = getAmountInCents(expectedAmount);
        return expectedAmountInCents > 0 && getAmountInCents(receivedAmount) >= expectedAmountInCents;
    };

    const validate = () => {
        const newErrors: any = {};
        const emiDetails = Array.isArray(totalEmildetail) ? totalEmildetail : [];
        // Step 1: Extract existing txn IDs from saved EMI detail
        const existingTransactionIds = new Set<string>();
        emiDetails.forEach((installment:any) => {
            if (installment.Payments && Array.isArray(installment.Payments)) {
                installment.Payments.forEach((payment: any) => {
                    if (payment.transaction_id && payment.is_advance_pay === 0) {
                        existingTransactionIds.add(payment.transaction_id.trim());
                    }
                });
            }
        });
        payments.forEach((payment, index) => {
            const amount = Number(payment.received_amount);
            if (!payment.mode_of_payment) newErrors[`mode_of_payment_${index}`] = "Mode of Payment is Required";
            if (!payment.received_amount) {
                newErrors[`received_amount_${index}`] = "Received Amount is Required";
            } else if (isNaN(amount) || amount <= 0) {
                newErrors[`received_amount_${index}`] = "Enter a valid amount";
            }
            if (!payment.received_amount) newErrors[`received_amount_${index}`] = "Received Amount is Required";
            // if (!payment.paid_to) newErrors[`paid_to_${index}`] = "Paid To is Required";
            if (!payment.paid_to) {
                // Set a default value if it's not set
                payment.paid_to = paidTo[0]?.value || null;
                if(!payment.paid_to){
                    // Add validation error if you still want to force user to confirm
                    newErrors[`paid_to_${index}`] = "Paid To is Required";
                }
            }
            if(isPaymentTypeShow){
                if (!payment.payment_type) newErrors[`payment_type_${index}`] = "Payment Type is Required";
            }
            if (!payment.payment_date) newErrors[`payment_date_${index}`] = "Payment Date is Required";
            // if (!payment.transaction_id) {
            //     newErrors[`transaction_id_${index}`] = "QR Code is Required";
            // }else if (!payment.hasOwnProperty('is_advance_pay')) {
            //     const txnId = payment.transaction_id.trim();
            //     if (existingTransactionIds.has(txnId)) {
            //         newErrors[`transaction_id_${index}`] = "Duplicate QR Code not allowed";
            //     }
            //     if (newTransactionIds.has(txnId)) {
            //         newErrors[`transaction_id_${index}`] = "Duplicate QR Code not allowed";
            //     } else {
            //         newTransactionIds.add(txnId);
            //     }
            // }
            // if (!payment.transaction_id) {
            //     newErrors[`transaction_id_${index}`] = "QR Code is Required";
            // }
            // if(payment.transaction_id){
            //     if (!payment.hasOwnProperty('is_advance_pay')) {
            //         const txnId = payment.transaction_id.trim();
            //         if (existingTransactionIds.has(txnId)) {
            //             newErrors[`transaction_id_${index}`] = "Duplicate QR Code not allowed";
            //         }
            //         if (newTransactionIds.has(txnId)) {
            //             newErrors[`transaction_id_${index}`] = "Duplicate QR Code not allowed";
            //         } else {
            //             newTransactionIds.add(txnId);
            //         }
            //     }
            // }
            if (!payment.paid_by_customer) newErrors[`paid_by_customer_${index}`] = "Paid By Customer is Required";
            // const hasNoProof = !payment.payment_proof || payment.payment_proof.trim() === "";
            // if (hasNoProof && !paymentFiles[index]) {
            //     newErrors[`payment_file_${index}`] = "Upload Proof is Required";
            // }
            if (+payment?.mode_of_payment === POST_DATED_CHEQUE_ID) {
                if (!payment.cheque_no) newErrors[`cheque_no_${index}`] = "Cheque no. is required";
                if (!payment.cheque_issue_date) newErrors[`cheque_issue_date_${index}`] = "Cheque issue date is required";
                if (!payment.cheque_due_date) newErrors[`cheque_due_date_${index}`] = "Due date for cheque is required";
                if (!payment.cheque_issuing_bank) newErrors[`cheque_issuing_bank_${index}`] = "Issuing bank is required";
            }
        });

        // Overpayment is intentionally allowed, so do not cap amount against remaining EMI/lead balance.

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
        try{
            setShowConfirmation(false);
            if (!validate()) {
                return;
            }
            setPageLoading(true);
            const paymentsCopy = structuredClone(payments);
            // Step 1: Prepare FormData for upload if any files exist
            const formData = new FormData();
            // formData.append('upload_type', 'insurance_ph_docs');
            // formData.append('upload_doc_type', 'insurance_ph_docs');
            // formData.append('sub_folder', 'sample_file');
            const uploadIndexes: number[] = [];
            // const fileEntries = Object.entries(paymentFiles).filter(([_, file]) => file);
            for (const [indexStr, file] of Object.entries(paymentFiles)) {
                const index = Number(indexStr);
                if (file instanceof File) {
                    formData.append('file', file);
                    uploadIndexes.push(index); // track the original index
                }
            }
            if (uploadIndexes.length > 0) {
                let uploadDocument: any = await addDocument(formData)
                if (uploadDocument.status !== 200 || uploadDocument.data?.status !== 200) {
                    throw new Error('Upload failed');
                }
                const uploadedFiles = uploadDocument.data.data; // this is an array
                // Step 3: Map file_name back into payments by index
                uploadIndexes.forEach((idx, i) => {
                    paymentsCopy[idx].payment_proof = uploadedFiles[i]?.file_name || '';
                });
            }
            const DISABLED_STATUSES = PAYMENT_DISSABLE_STATUS;
            paymentsCopy.forEach(payment => {
                payment.received_amount = String(payment.received_amount);
                payment.isHistoryCreate = !DISABLED_STATUSES.includes(payment?.finance_reco_status);
                delete payment?.proof_url;
                delete payment?.finance_reco_status;
                delete payment?.finance_status;
                delete payment?.reco_status;
                delete payment?.payment_verified_date;
                delete payment?.is_advance_pay;
            });
            const payload = {
                payments: paymentsCopy,
                lead_id: id,
                installment_no: emiData?.installment_no || 1,
                is_manual:true
            };
            const response:any = await updateLeadEmiDetail(payload);
            if (response?.status === 200) {
                setIsNewRecord(false);
                await reloadEmiDetails();
                setCallReloadApi((prev:any) => prev + 1);
            }
        }catch (error) {
            console.error("Error while updating EMI detail:", error);
        }finally {
            setPageLoading(false);
        }
    };

    const validatePayment = async () => {
        if (!validate()) {
            return;
        }
        setShowConfirmation(true);
    }

    useEffect(() => {
        if (id) {
            getMasterConfigApi();
            if (!commonState?.bankList?.length) {
                dispatch(getBankList()).then((res: any) => {
                    if (res && res.status === 200) {
                        setIssuingBank((prev: any) => [...prev, ...res.data]);
                    }
                })
            } else {
                setIssuingBank(commonState?.bankList);
            }
        }
        // eslint-disable-next-line
    }, [id]);

    const getMasterConfigApi = () => {
    setPageLoading(true);
    dispatch(getMasterConfig())
        .then((res: any) => {
        if (res && res.status === 200) {
            if (res.data) {
                setPaidTo(res?.data?.paid_to);
                setPaymentMethod(res?.data?.payment_method)
                setPaidByCustomer(res?.data?.paid_by_customer)
            }
        }
        })
        .catch((err: Error) => {
            console.error("Error fetching master config:", err);
        })
        .finally(() => {
        setPageLoading(false);
        });
    };

    const handleRemovePayment = (indexToRemove: any) => {
        const updatedPayments = payments.filter((_, index) => index !== indexToRemove);
        setPayments(updatedPayments);
        const hasNewRecords = updatedPayments.some(payment => !payment?.id);
        setIsNewRecord(hasNewRecords);
    }
 

    const isPaymentDisabled = (payment: any) => isOverpaidTab || PAYMENT_DISSABLE_STATUS.includes(payment.finance_reco_status);
    const isManualPayment = (payment: any) => Number(payment?.is_manual) === 1 || payment?.is_manual === true || !payment?.id;
    const isPaysoQrPayment = (payment: any) => Number(payment?.mode_of_payment) === PAYSO_PAYMENT_ID && !isManualPayment(payment);
    const partnerId = leadDetail?.partner_slug ?? leadProcessingDetail?.partner_slug;
    const paymentMethodOptions = PARTNERS_ONLY_FOR_CREDIT_CARD.includes(partnerId)
        ? paymentMethod
        : paymentMethod.filter((method: any) => String(method?.slug) !== CREDIT_CARD_PAYMENT_ID);

    const renderPaymentSection = (payment: any, index: number) => (
        <>
            {
                ALERT_STATUS.includes(payment.finance_reco_status) && (
                    <>
                        {
                            (payment.finance_reco_status === 2 || payment.finance_reco_status === 5) && +emiData?.received_amount >= +emiData?.installment_expected_amount && (
                                <div className='verification-process-msg status-process-msg m-lg-t'>
                                    <i className='ic-more_vert'></i> <span>{payment.status_name}.</span> Payment is under verification through {+payment.mode_of_payment === POST_DATED_CHEQUE_ID ? `Finance Team` : `Reco Team`}
                                </div>
                            )
                        }
                        {
                            (payment.finance_reco_status === 2 || payment.finance_reco_status === 5) && +emiData?.received_amount < +emiData?.installment_expected_amount && (
                                <div className='verfied-in-process-msg status-process-msg m-lg-t'>
                                    <i className='ic-more_vert'></i> <span>{payment.status_name}.</span> Outstanding Balance is ₱{(emiData?.installment_expected_amount - emiData?.received_amount).toFixed(2)}
                                </div>
                            )
                        }
                        {
                            (payment.finance_reco_status === 3 || payment.finance_reco_status === 6 || payment.finance_reco_status === 8) && (
                                <div className='verfied-process-msg status-process-msg m-lg-t'>
                                    <i className='ic-check'></i> <span>{payment.status_name}</span> On {payment.payment_verified_date}
                                </div>
                            )
                        }
                        {
                            (payment.finance_reco_status === 4 ||  payment.finance_reco_status === 7) && (
                                <div className='verfied-failed-msg status-process-msg m-lg-t'>
                                    <i className='ic-clearclose'></i> <span>{payment.status_name}</span> On {payment.payment_verified_date}
                                </div>
                            )
                        }
                    </>
                )
            }
            <div className="row" key={index}>
                <div className="lead-form-heading col-md-12 mb-2 emi-detail">
                    <h2>Payment {index + 1}</h2>
                    {   
                        !payment?.id && payments.length > 1 && index === payments.length - 1 &&
                        <button className="close_icn" onClick={() => handleRemovePayment(index)}>
                            <i className="ic-clearclose"></i>
                        </button>
                    }
                </div>
                <fieldset className= {isInstallments ? "single-select col-md-4" : "single-select col-md-3"}>
                    <div className="material">
                        <Select
                            components={{ ValueContainer: CustomValueContainer }}
                            options={paymentMethodOptions}
                            placeholder="Mode of Payment *"
                            className="react-select"
                            classNamePrefix="react-select"
                            value={ paymentMethod.find((b) => Number(b.value) === Number(payment?.mode_of_payment)) || null }
                            onChange={(option) => handleFieldChange(index, "mode_of_payment", option?.value)}
                            isDisabled={isPaymentDisabled(payment)}
                        />
                    
                    {errors[`mode_of_payment_${index}`] && (
                        <span className="error">{errors[`mode_of_payment_${index}`]}</span>
                    )}
                    </div>
                </fieldset>

                <fieldset className={isInstallments ? "col-md-4" : "col-md-3"}>
                    <div className="material">
                        <input type="text"
                            placeholder=" "
                            name="amountReceived"
                            className="form-input"
                            value={isPaymentDisabled(payment) ? HELPER.addCurrencyFormatting(payment?.amount_to_show) : (payment?.received_amount || "")}
                            onChange={(e) => handleFieldChange(index, "received_amount", e.target.value)}
                            disabled={isPaymentDisabled(payment)}
                        />
                        <label data-label="Amount Received *" className="form-label"></label>
                        {(errors[`received_amount_${index}`] || errors[`totalAmountExceeded_${index}`]) && (
                            <div className="error text-danger mb-2">
                                {errors[`received_amount_${index}`] && <div>{errors[`received_amount_${index}`]}</div>}
                                {errors[`totalAmountExceeded_${index}`] && <div>{errors[`totalAmountExceeded_${index}`]}</div>}
                            </div>
                        )}
                    </div>
                </fieldset>

                <fieldset className= {isInstallments ? "single-select col-md-4" : "single-select col-md-3"}>
                    <div className="material">
                        <Select
                            components={{ ValueContainer: CustomValueContainer }}
                            options={paidTo}
                            placeholder="Paid to *"
                            className="react-select"
                            classNamePrefix="react-select"
                            value={ paidTo.find((b) => Number(b.value) === Number(payment?.paid_to)) || paidTo[0]  || null }
                            onChange={(option) => handleFieldChange(index, "paid_to", option?.value)}
                            isDisabled={isPaymentDisabled(payment)}
                        />
                    
                    {errors[`paid_to_${index}`] && (
                        <span className="error">{errors[`paid_to_${index}`]}</span>
                    )}
                    </div>
                </fieldset>


                {
                    isInstallments && isPaymentTypeShow ? <>
                    <fieldset className={`form-group radio-type-txt ${ isInstallments ? "col-md-4" : "col-md-3"} radio-btn payment-radio`}>
                            <label className="form-label d-block">Payment Type *</label>
                            {PAYMENT_TYPE_RADIO.map((val:number) => (
                            <div className="custom-control custom-checkbox inline-block m-lg-r" key={val}>
                                <input type="radio" className="custom-control-input" name={`paymentType_${index}`}
                                value={val} checked={payment?.payment_type === val} onChange={() => handleFieldChange(index, "payment_type", val)} disabled={isPaymentDisabled(payment)}/>
                                <label className="custom-control-label" htmlFor={`paymentType_${val}_${index}`} >
                                {val === 1 ? "Single" : "Bulk"}
                                </label>
                            </div>
                            ))}
                            {errors[`payment_type_${index}`] && (
                            <span className="error">{errors[`payment_type_${index}`]}</span>
                            )}
                        </fieldset>   
                    </> : null
                }    
                <fieldset className={isInstallments ? "col-md-4" : "col-md-3 receiveDateShow"}>
                    <div className="material">
                        <ReceivedDate
                            placeholder="Receive Date *"
                            selectedDate={ payment?.payment_date ? new Date(payment.payment_date) : null }
                            onDateChange={(date) => handleFieldChange(index, "payment_date", date?.toISOString())}
                            disabled={isPaymentDisabled(payment)}
                        />
                        {errors[`payment_date_${index}`] && (
                            <span className="error">{errors[`payment_date_${index}`]}</span>
                        )}
                    </div>
                </fieldset>   

                {
                    !isInstallments && isPaymentTypeShow ? <>
                    <fieldset className={`form-group radio-type-txt ${ isInstallments ? "col-md-4" : "col-md-3"} radio-btn payment-radio`}>
                            <label className="form-label d-block">Payment Type *</label>
                            {PAYMENT_TYPE_RADIO.map((val:number) => (
                            <div className="custom-control custom-checkbox inline-block m-lg-r" key={val}>
                                <input type="radio" className="custom-control-input" name={`paymentType_${index}`}
                                value={val} checked={payment?.payment_type === val} onChange={() => handleFieldChange(index, "payment_type", val)} disabled={isPaymentDisabled(payment)}/>
                                <label className="custom-control-label" htmlFor={`paymentType_${val}_${index}`} >
                                {val === 1 ? "Single" : "Bulk"}
                                </label>
                            </div>
                            ))}
                            {errors[`payment_type_${index}`] && (
                            <span className="error">{errors[`payment_type_${index}`]}</span>
                            )}
                        </fieldset>   
                    </> : null
                }  
                 

                <fieldset className={isInstallments ? "col-md-4" : "col-md-3"}>
                    <div className="material">
                        <input type="text" placeholder=" " name="transactionId" className="form-input" value={payment?.transaction_id || ""} readOnly={!!emiData?.transaction_id}
                        onChange={(e) => handleFieldChange(index, "transaction_id", e.target.value)} disabled={isPaymentDisabled(payment)}/>
                        <label data-label="QR Code" className="form-label"></label>
                        {errors[`transaction_id_${index}`] && (
                            <span className="error">{errors[`transaction_id_${index}`]}</span>
                        )}
                    </div>
                </fieldset>

                <fieldset className= {isInstallments ? "single-select col-md-4" : "single-select col-md-3"}>
                    <div className="material">
                        <Select
                            components={{ ValueContainer: CustomValueContainer }}
                            options={paidByCustomer}
                            placeholder="Paid By Customer *"
                            className="react-select"
                            classNamePrefix="react-select"
                            value={ paidByCustomer.find((b) => Number(b.value) === Number(payment?.paid_by_customer)) || null }
                            onChange={(option) => handleFieldChange(index, "paid_by_customer", option?.value)}
                            isDisabled={isPaymentDisabled(payment)}
                        />
                    </div>
                    {errors[`paid_by_customer_${index}`] && (
                        <span className="error">{errors[`paid_by_customer_${index}`]}</span>
                    )}
                </fieldset>

                <div className={isInstallments ? "col-md-4 p-lg-b" : "col-md-3 p-lg-b"}>
                    {(isOverpaidTab || isPaysoQrPayment(payment)) ? (
                        <div className="material">
                            <input
                                type="text"
                                placeholder=" "
                                name="paymentProofVerified"
                                className="form-input"
                                value={PAYSO_QR_VERIFIED_TEXT}
                                disabled
                                readOnly
                                style={{ paddingRight: "40px" }}
                            />
                            <label data-label="Upload Proof" className="form-label"></label>
                            <i
                                className="ic-password"
                                style={{
                                    color: "#9D9D9D",
                                    position: "absolute",
                                    right: "15px",
                                    top: "18px"
                                }}
                            ></i>
                        </div>
                    ) : (
                        <div className="attech-repair-doc">
                            <div className='upload-text'>
                            <i className="ic-attach_file"></i>
                            <input type="file" name="repairDocs" ref={(el) => (fileInputRefs.current[index] = el)}
                            disabled={isPaymentDisabled(payment)}
                            onChange={(e) => {                            
                                const file = e.target.files?.[0] || null;
                                setPaymentFiles((prev) => ({ ...prev, [index]: file }));
                                errors[`payment_file_${index}`] = '';
                                setErrors({ ...errors });
                                if (fileInputRefs.current[index]) {
                                    fileInputRefs.current[index]!.value = '';
                                }
                            }}
                            />
                            <p>Upload Proof</p>
                            </div>
                            {paymentFiles[index] && (
                                <div className="uploaded-file">
                                    <div className='upload-file-name'>
                                        <a
                                            href={(paymentFiles[index] as { name: string; url: string }).url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            >
                                            {paymentFiles[index]?.name}
                                        </a>
                                    </div>
                                {!isPaymentDisabled(payment) && (
                                        <span
                                            className="remove-icon"
                                            onClick={() => {
                                            setPaymentFiles((prev) => ({ ...prev, [index]: null }));
                                            }}
                                        >
                                            ✕
                                        </span>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                    {errors[`payment_file_${index}`] && (
                        <span className="error">{errors[`payment_file_${index}`]}</span>
                    )}
                </div>
            </div>
            {
                +payment?.mode_of_payment === POST_DATED_CHEQUE_ID &&
                <div className="estimate-detail-sec" key={`cheque_${index}`}>
                    <h3>Cheque Details</h3>
                    <div className="row">
                        <fieldset className= {isInstallments ? "col-md-4" : "col-md-3"}>
                            <div className="material">
                                <input type="text" placeholder=" " name="cheque_no" className="form-input" value={payment?.cheque_no || ""}
                                onChange={(e) => handleFieldChange(index, "cheque_no", e.target.value)}
                                disabled={isPaymentDisabled(payment)}
                                />
                                <label data-label="Cheque No.*" className="form-label"></label>
                                {errors[`cheque_no_${index}`] &&  <span className="error">{errors[`cheque_no_${index}`]}</span> }
                            </div>
                        </fieldset>
                        <fieldset className= {isInstallments ? "col-md-4" : "col-md-3"}>
                            <div className="material">
                            <ReceivedDate placeholder="Cheque Issue Date*" selectedDate={ payment?.cheque_issue_date ? new Date(payment.cheque_issue_date) : null }
                                onDateChange={(date) => handleFieldChange(index, "cheque_issue_date", date?.toISOString())}
                                disabled={isPaymentDisabled(payment)}
                            />
                            {errors[`cheque_issue_date_${index}`] &&  <span className="error">{errors[`cheque_issue_date_${index}`]}</span> }
                            </div>
                        </fieldset>
                        <fieldset className= {isInstallments ? "col-md-4" : "col-md-3"}>
                            <div className="material">
                            <ReceivedDate placeholder="Due Date for Cheque*" selectedDate={ payment?.cheque_due_date ? new Date(payment.cheque_due_date) : null }
                                onDateChange={(date) => handleFieldChange(index, "cheque_due_date", date?.toISOString())}
                                disabled={isPaymentDisabled(payment)}
                            />
                            {errors[`cheque_due_date_${index}`] &&  <span className="error">{errors[`cheque_due_date_${index}`]}</span> }
                            </div>
                        </fieldset>
                        <fieldset className= {isInstallments ? " single-select col-md-4" : "single-select col-md-3"}>
                            <div className="material">
                                <Select
                                components={{ ValueContainer: CustomValueContainer }}
                                options={IssuingBank}
                                placeholder="Issuing Bank *"
                                className="react-select"
                                classNamePrefix="react-select"
                                value={ IssuingBank.find((b) => Number(b.value) === Number(payment?.cheque_issuing_bank)) || null }
                                onChange={(option) => handleFieldChange(index, "cheque_issuing_bank", option?.value)}
                                isDisabled={isPaymentDisabled(payment)}
                                />
                                {errors[`cheque_issuing_bank_${index}`] &&  <span className="error">{errors[`cheque_issuing_bank_${index}`]}</span> }
                            </div>
                        </fieldset>
                    </div>
                </div>
            }
        </>
    );

    const handleAddPayment = () => {
        const newPayment = {
            lead_installment_id:emiData.id,
            received_amount: '',
            paid_to: null,
            payment_type: null,
            payment_date: null,
            transaction_id : emiData?.transaction_id,
        };
        setPayments([...payments, newPayment]);
        setIsNewRecord(true);
    };

    // const shouldShowAddPaymentButton = isInstallments
    //     ? emiData?.Payments.length > 0 && (emiData?.received_amount < emiData?.installment_expected_amount)
    //     : emiData?.received_amount < emiData?.total_premium;

    // const buttonShouldDissable = isInstallments
    //     ? emiData?.Payments.length > 0 && (emiData?.received_amount >= emiData?.installment_expected_amount)
    //     : emiData?.received_amount >= emiData?.total_premium;

    const expectedAmount = emiData?.installment_expected_amount ?? emiData?.total_premium;
    const hasPayments = emiData?.Payments?.length > 0;
    const isCurrentPaid = isAmountPaid(emiData?.received_amount, expectedAmount);

    let isPrevUnpaid = false;
    if (selectedIndex > 0 && totalEmildetail[selectedIndex - 1]) {
        const prevEMI = totalEmildetail[selectedIndex - 1];
        const prevExpected = prevEMI?.installment_expected_amount ?? prevEMI?.total_premium;
        isPrevUnpaid = !isAmountPaid(prevEMI?.received_amount, prevExpected);
    }
    let isPaymentRejected = false;
    if(!isOverpaidTab && emiData?.Payments?.length > 0){
        isPaymentRejected = payments.some(
            (payment: any) => payment.finance_reco_status === 4 || payment.finance_reco_status === 7
        );
    }

    // const shouldShowAddPaymentButton = hasPayments && emiData?.received_amount < expectedAmount;
    let buttonShouldDissable = isOverpaidTab || (hasPayments && isCurrentPaid) || isPrevUnpaid || isWholeLeadPaymentDone;
    let isAutoCreated = false;
    let isPaymentSaved = false;
    if(!isOverpaidTab && emiData?.Payments?.length > 0){
        isAutoCreated = payments.some((payment: any) => payment.auto_created === 1 && !PAYMENT_DISSABLE_STATUS.includes(payment.status) && (+payment.mode_of_payment === POST_DATED_CHEQUE_ID ? !payment.assigned_finance_id : !payment.assigned_reco_id));
        isPaymentSaved = payments.every((payment: any) => !PAYMENT_DISSABLE_STATUS.includes(payment.status) && (+payment.mode_of_payment === POST_DATED_CHEQUE_ID ? !payment.assigned_finance_id : !payment.assigned_reco_id));
    }
    let shouldShowAddPaymentButton = hasPayments && !isCurrentPaid && !isOverpaidTab;
    if(isPaymentSaved){
        shouldShowAddPaymentButton = false;
    }
  
    // if button is not dissabled
    if(!buttonShouldDissable && hasPayments){
        // and also there is not new element inserted
        if(isNewRecord === false){
            buttonShouldDissable = true;
        }
    }

    if(isAutoCreated){
        buttonShouldDissable = false
    }

    const reloadApi = () => {
        setCallReloadApi((prev:any) => prev + 1);
    };

    const shouldShowInstallmentActions = Number(leadDetail?.lead_type_id) === 8 || Number(leadDetail?.lead_source_id) === 9;
    const isLeadOverPaid = Number(leadDetail?.lead_status_id) === 9;
    const isNeedToDissable = isWholeLeadPaymentDone || leadDetail?.qrCodeDetails === null
    const isActionButtonDisabled = isOverpaidTab || (isPaymentRejected === true ? false : buttonShouldDissable);
    const overpaidAmount = emiData?.overpaid_amount ?? 0;

    return (
        <>
            {!isLeadDetailLoaderControlled && <FullPageLoader show={loading} />}
            <div className="form-tab-right-panel">
                <div className="lead-detail-from-outer">
                    <div className="emi-detail-header">
                        {
                            isOverpaidTab ? (
                                <div
                                    className="lead-form-heading emi-detail-heading"
                                    style={{
                                        border: "1px solid rgba(0, 140, 240, 0.12)",
                                        borderRadius: "6px",
                                        color: "#4F5B67",
                                        flex: "1 1 100%",
                                        fontSize: "13px",
                                        padding: "12px 14px"
                                    }}
                                >
                                    <i className="ic-info-icon1" style={{ color: "#008CF0", marginRight: "10px" }}></i>
                                    <span>
                                        Customer has overpaid <strong style={{ color: "#F29900" }}>{HELPER.addCurrencyFormatting(overpaidAmount)}</strong>. Amount will be refunded once refund flow is enabled.
                                    </span>
                                </div>
                            ) : (
                                <>
                                    <div className="lead-form-heading emi-detail-heading">
                                        <h2>Instalment Details
                                            {emiData?.installment_expected_amount && ` (EMI ${HELPER.addCurrencyFormatting(emiData?.installment_expected_amount)})`}
                                        </h2>
                                    </div>
                                    <EmiInstallmentActions
                                        shouldShow={shouldShowInstallmentActions}
                                        isOverPaid={isLeadOverPaid}
                                        isCurrentPaid={isNeedToDissable}
                                        installmentNo={emiData?.installment_no}
                                        qrCodeDetails={leadDetail?.qrCodeDetails}
                                        reloadDetails={reloadApi}
                                        setLeadDetailLoading={setLeadDetailLoading}
                                    />
                                </>
                            )
                        }
                    </div>
                    
                    <div className="lead-form-filed p-lg-t">
                
                        {payments.map((payment, index) => renderPaymentSection(payment, index))}

                        { shouldShowAddPaymentButton && !isWholeLeadPaymentDone && (
                            <div className="add_new_payment">
                                <button type="button" className="btn-primary" onClick={handleAddPayment}>
                                    Add New Payment
                                </button>
                            </div>
                        )}
                        

                        {/* {
                            isPaymentMethodChecq &&
                            <ChequeDetails
                                chequeNo={chequeDetails.cheque_no}
                                chequeIssueDate={chequeDetails.cheque_issue_date}
                                chequeDueDate={chequeDetails.cheque_due_date}
                                cheque_issuing_bank={chequeDetails.cheque_issuing_bank}
                                setChequeDetails={setChequeDetails}
                                errors={errors}
                                checkChqueDissable={isChqueDissable}
                                isInstallments = {isInstallments}
                            />
                        } */}
                        {
                            +leadSubStatusId === LEAD_LOST_SUB_STATUS_ID ?
                            <>
                                <div className="btn-continue">
                                    <button type="button" className="btn-primary" disabled={true}>Validate</button>
                                    <button type="button" className="btn-line" disabled={true}>Mark Status & Follow-up</button>
                                </div>
                            </>
                            :
                            <>
                                <div className="btn-continue">
                                    <button type="button" className="btn-primary" onClick={() => validatePayment()} disabled={isActionButtonDisabled}>Validate</button>
                                    <button type="button" className="btn-line" disabled={isActionButtonDisabled} onClick={() => setFollowUpPopup(true)}>Mark Status & Follow-up</button>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>
            {showConfirmation === false ? ("") : (
                <ConfirmPopUp
                    confirmNo={() => setShowConfirmation(false)}
                    confirmYes={handleSubmit}
                    // message={`Are You Sure, You Want To Validate This Payment Via ${isPaymentMethodChecq? 'Finance': 'Reco'} Team?`}
                    message={`Are You Sure, You Want To Validate This Payment ?`}
                    isConfirmNotVisible={true} 
                    from={"EmiComponent"}
                />
            )}
            {followUpPopup ?
                <FollowUpPopup
                    followUpPopup={followUpPopup}
                    showFollowupPopup={(e: boolean) => setFollowUpPopup(e)}
                    leadId={+emiData?.lead_id}
                    showLostStatus={isLostStatusVisible}
                    reloadApi={reloadApi}
                /> : ''
            }
        </>
    );
};

export default EmiComponent;
